/// <reference types="@angular/localize" />
import { provideZoneChangeDetection } from '@angular/core';
import '@angular/common/locales/global/se';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';

platformBrowserDynamic().bootstrapModule(AppModule, {
  applicationProviders: [provideZoneChangeDetection()],
})
  .catch(err => console.error(err));
